export default __webpack_public_path__ + "static/media/gps.ba5ddd1d.svg";